import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import styles from "../../styles/Tech.module.css";

const BlogCardTechLts = ({ title, src, alt, date, time, slug, desc }) => {
    const router = useRouter();

    return (
        <div className={`flex justify-between cursor-pointer  ${styles.blog_lts_container}`} onClick={() => router.push(`/blog/${slug}/`)}>
            <div className="flex items-center justify-center w-4/5 sm:w-2/5 relative ">
                <div className={styles.blog_lts_img}>
                    <Image
                        src={src}
                        alt={alt}
                        width="150"
                        height="200"
                        layout="fill"
                        sizes="(max-width: 500px) 50vw,
          (max-width: 1200px) 70vw,
          100vw"
                    />
                </div>
                <div className={styles.blog_lts_img_bg}></div>
            </div>
            <div className={`flex flex-col  ${styles.blog_lts_content}`}>
                <h5>{title}</h5>
                <div className={`flex justify-between ${styles.blog_date}`}>
                    <p>{date}</p>
                    <p>{time}</p>
                </div>
                <p className={styles.blog_desc}>{desc}</p>

                <div onClick={() => router.push(`/blog/${slug}/`)} className="flex justify-between ml-2 cursor-pointer">
                    <div className="flex  items-center">
                        <svg className="mr-2 " height="20" width="20">
                            <circle cx="10" cy="10" r="7" stroke="black" strokeWidth="0.5" fill="#C30B0B" />
                        </svg>
                        <p>Read Now</p>
                    </div>
                    <div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="4"
                            stroke="currentColor"
                            className="w-4 h-4 ml-3"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCardTechLts;
